module.exports = __webpack_public_path__ + "img/volume.0a5ba2a6.png";